import axios from 'axios';
import CheckToken from '../../../utils/checkToken/CheckToken';

export const getNotificaitionReportAsExcel = async (startDate, endDate) => {
    const token = await CheckToken();
    if (!token) {
        // Redirect to login page
        window.location.href = '/login';
    }

    // URL'yi manuel olarak oluştur
    const url = `${process.env.REACT_APP_API_URL}/tax/get-history-as-excel?startDate=${startDate}&endDate=${endDate}`
    return await axios.get(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};
